import { faArrowsRotate } from '@fortawesome/pro-duotone-svg-icons';
import { useState } from 'react';
import { Button } from '@/design-system/primitives/Button';
import { IconDisc } from '@/design-system/primitives/IconDisc';
import { Modal } from '@/design-system/primitives/Modal';

export interface RefreshConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Resolves once invalidation + re-fetch is kicked off (modal closes immediately on confirm). */
  onConfirm: () => Promise<void>;
}

export const RefreshConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
}: RefreshConfirmationModalProps) => {
  const [isWorking, setIsWorking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setIsWorking(true);
    setError(null);
    try {
      await onConfirm();
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Refresh failed');
    } finally {
      setIsWorking(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Body>
        <div className="flex justify-center mb-4">
          <IconDisc icon={faArrowsRotate} size="lg" tone="primary" />
        </div>
        <h2 className="font-diary text-xl text-content-text text-center mb-2">
          Refresh place data?
        </h2>
        <p className="text-sm text-content-text leading-relaxed text-center">
          Refreshing all places for this area will incur API service charges. Cached results from
          previous searches in this area will be discarded.
        </p>
        {error && (
          <p className="mt-3 text-xs text-danger-text bg-danger-background rounded-lg px-3 py-2 text-center">
            {error}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="ghost" onClick={onClose} disabled={isWorking}>
          Cancel
        </Button>
        <Button onClick={() => void handleConfirm()} disabled={isWorking}>
          {isWorking ? 'Refreshing…' : 'Refresh'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
